"use strict";

exports.__esModule = true;
exports.DataItemTypeSelect = void 0;
var _Selector = require("../../Core/Selector");
var _react = _interopRequireWildcard(require("react"));
var _EnrichDefinitionContext = require("../EnrichDefinitionContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var DataItemTypeSelect = exports.DataItemTypeSelect = function DataItemTypeSelect(props) {
  var _useContext = (0, _react.useContext)(_EnrichDefinitionContext.EnrichDefinitionContext),
    device = _useContext.device,
    contextDataItems = _useContext.dataItems;
  var _useState = (0, _react.useState)([]),
    dataItems = _useState[0],
    setDataItems = _useState[1];
  var distinctDataItems = function distinctDataItems(value, index, self) {
    return self.indexOf(value) === index;
  };
  (0, _react.useEffect)(function () {
    var _ref;
    setDataItems((_ref = (contextDataItems == null ? void 0 : contextDataItems.length) > 0 ? contextDataItems : device == null ? void 0 : device.dataItems) == null ? void 0 : _ref.map(function (dataItem) {
      return dataItem.type;
    }).filter(distinctDataItems).map(function (dataItem) {
      return {
        type: dataItem,
        name: ""
      };
    }));
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    dataTestId: "EnrichEditorUI.DeviceSelect.DataItems.Type",
    items: dataItems != null ? dataItems : [],
    getKey: function getKey(item) {
      return item.type;
    },
    renderItemText: function renderItemText(item) {
      return item.type;
    },
    renderItemLabel: function renderItemLabel(item) {
      return item.name;
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.type.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  }, props));
};